import { jsx as _jsx } from "react/jsx-runtime";
import times from 'lodash/times';
import devNote from '@xingternal/dev-note';
import { cornerRadiusS, scale060 } from '@xingternal/tokens';
import * as Styled from './skeleton-body-copy.styles';
export const SkeletonBodyCopy = ({ alignment = 'left', amountRows = 2, className, variant, ...props }) => {
    if (variant) {
        devNote.deprecate("The variant property is deprecated and should be removed. Variant 'secondary' is automatically mapped to 'primary'.");
    }
    return (_jsx(Styled.BodyCopy, { "$alignment": alignment, className: className, "data-xds": "SkeletonBodyCopy", ...props, children: times(amountRows, (i) => (_jsx(Styled.BodyCopyRow, { "$amountRows": amountRows, cornerRadius: cornerRadiusS, height: scale060 }, i))) }));
};
SkeletonBodyCopy.displayName = 'SkeletonBodyCopy';
//# sourceMappingURL=skeleton-body-copy.js.map